import type { PropsWithChildren } from 'react';

import { AppCrashModal } from '@/components/fatality/AppCrashModal.tsx';
import { ErrorFromRedux } from '@/components/fatality/ErrorFromRedux.ts';
import { useAppSelector } from '@/store/hooks.ts';

let error: Error | undefined;

export const ReduxErrorCatcher = ({ children }: PropsWithChildren) => {
  const reduxFatalityState = useAppSelector(({ reduxFatality }) => reduxFatality);

  if (!error && reduxFatalityState.errorCaught) {
    // will prevent any infinite loop in redux error processing, whatever reason the reason is
    error = new ErrorFromRedux(
      reduxFatalityState.errorMessage,
      reduxFatalityState.errorStack,
      reduxFatalityState.action,
    );
  }

  return error ? <AppCrashModal error={error} onReload={() => window.location.reload()} /> : children;
};
